import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
///////////////////////////main////////////////////////////
import Login from "./Components/profile/Login";
import Register from "./Components/profile/Register";
import Home from "./Components/profile/Home";
import ProfileUser from "./Components/profile/ProfileUser";
import EditProfileUser from "./Components/profile/EditProfileUser";
import Navbar from "./Components/profile/Navbar-Parent";

//////////////////////////////Admin///////////////
import Dashboard from "./Components/admin/Dashboard";

////////////////////////pilot////////////////////////
import RegisPilot from "./Components/user/pilot/RegisPilot";
import RegisPilotSpacific from "./Components/user/pilot/RegisPilotSpacific";
import StatusPilot from "./Components/user/pilot/StatusPilot";

import RegisOperation from "./Components/user/pilot/RegisPilot";
///////////////////////Drone/////////////////////////
import RegisDrone from "./Components/user/drone/RegisDrone";
import StatusDrone from "./Components/user/drone/StatusDrone";
import StatusDroneSec from "./Components/user/drone/StatusDroneSec";
import StatusDronelast from "./Components/user/drone/StatusDronelast";
import EditRegisDrone from "./Components/user/drone/EditRegisDrone";
import Regisremote from "./Components/user/drone/Regisremote";
import PilotStatus from "./Components/user/drone/PilotStatus";
import UpdatePolygon from "./Components/user/drone/UpdatePolygon";

/////////////////////operation///////////////////////

import DroneMonitor from "./Components/user/operation/DroneMonitor";
import DroneMonitorSocket from "./Components/user/operation/DroneMontoringSocket";

import PolygonLeafLet from "./Components/user/operation/PolygonLeafLet";
import JoinOperation from "./Components/user/operation/JoinOperation";
import OperationTable from "./Components/user/drone/OperationTable";
import OperationDisplay from "./Components/user/operation/Displays";
import LeafletLab from "./Components/user/operation/LeafletLab";
import SphereShortestPath from "./Components/user/operation/SphereShortestPath";
import FullAgreementPage from "./Components/user/operation/FullAgreementPage";
import Agreement from "./Components/user/operation/Agreement";

///////////////////////////// Regulator///////////////////////////////////
import RegulatorStatusflightDrone from "./Components/regulator/RegulatorStatusflightDrone ";
import RegulatorDrone from "./Components/regulator/RegulatorDrone";
import RegulatorDroneMonitoring from "./Components/regulator/RegulatorDroneMonitoring";
import CaatPilotApproval  from "./Components/regulator/CaatPilotApproval";
//////////////////////////////service//////////////////////////////
import PrivateRoutes from "./services/PrivateRoutes";
import PrivateRoutes2 from "./services/PrivateRoutes2";
import AgencyOperationStatus from "./Components/agency/AgencyOperationStatus";
import AgencyPolygonCreation from "./Components/agency/AgencyPolygonCreation";
import CaatOperationStatus from "./Components/regulator/CaatOperationStatus";
import StatusOperatingPilot from "./Components/user/pilot/StatusOperatingPilot";
import Datadrone from "./Components/user/drone/Datadrone";
import Welcome from "./Components/profile/Welcome";

//////ETC
import Notification from "./Components/user/etc/Notification";

const Routers = () => {
  const type_user = sessionStorage.getItem("type_user");
  const location = useLocation();
  const pathsToHideNavbar = ["/login", "/register", "/welcome", "/"];
  const shouldShowNavbar = !pathsToHideNavbar.includes(location.pathname);
  const pathToHideNoti = [
    "/user/operation/operationdisplays",
    "/user/operation/polygonLeaflet",
    "/user/operation/joinoperation",
    "/login",
    "/register",
    "/welcome",
    "/",
    "/agency/AgencyPolygonCreation",
  ];
  const shouldShowNoti = !pathToHideNoti.includes(location.pathname);
  return (
    <div>
      {shouldShowNavbar && <Navbar />}
      {/* <ReactKeycloakProvider authClient={keycloakConfig}> */}
      <Routes>
        <Route element={<PrivateRoutes2 />}>
          {/* <Route
            exact
            path="*"
            element={<Home />}
          /> */}

          <Route
            exact
            path="/regulator/caatoperationstatus"
            element={<CaatOperationStatus />}
          />
          <Route
            exact
            path="/agency/agencyoperationstatus"
            element={<AgencyOperationStatus />}
          />
          <Route
            exact
            path="/agency/AgencyPolygonCreation"
            element={<AgencyPolygonCreation />}
          />

          <Route
            exact
            path="/profile/editprofileuser"
            element={<EditProfileUser />}
          />
          <Route exact path="/profile/profileuser" element={<ProfileUser />} />

          <Route exact path={"/home"} element={<Home />} />

          <Route exact path="/user/pilot/regispilot" element={<RegisPilot />} />
          <Route
            exact
            path="/user/pilot/regispilotspacific"
            element={<RegisPilotSpacific />}
          />
          <Route
            exact
            path="/user/pilot/statuspilot"
            element={<StatusPilot />}
          />
          <Route
            exact
            path="/user/pilot/statusoperatingpilot"
            element={<StatusOperatingPilot />}
          />
          <Route exact path="/admin/dashboard" element={<Dashboard />} />
          <Route exact path="/user/drone/dataDrone" element={<Datadrone />} />
          <Route
            exact
            path="/user/drone/statusDrone"
            element={<StatusDrone />}
          />
          <Route
            exact
            path="/user/drone/statusDroneSec"
            element={<StatusDroneSec />}
          />
          <Route
            exact
            path="/user/drone/statusDronelast"
            element={<StatusDronelast />}
          />
          <Route exact path="/user/drone/regisDrone" element={<RegisDrone />} />
          <Route
            exact
            path="/user/drone/editRegisDrone"
            element={<EditRegisDrone />}
          />

          <Route
            exact
            path="/user/drone/regisremote"
            element={<Regisremote />}
          />

          <Route
            exact
            path="/user/drone/pilotstatus"
            element={<PilotStatus />}
          />

          <Route
            exact
            path="/user/drone/updatepolygon"
            element={<UpdatePolygon />}
          />

          <Route
            exact
            path="/user/operation/regisoperation"
            element={<RegisOperation />}
          />

          <Route
            exact
            path={"/user/operation/dronemonitor"}
            element={<DroneMonitor />}
          />
          <Route
            exact
            path={"/user/operation/dronemonitorsocket"}
            element={<DroneMonitorSocket />}
          />
          <Route
            exact
            path={"/user/operation/operationdisplays"}
            element={<OperationDisplay />}
          />
          <Route
            exact
            path="/user/operation/polygonLeaflet"
            element={<PolygonLeafLet />}
          />
          <Route
            exact
            path="/user/operation/full-agreement-page"
            element={<FullAgreementPage />}
          />
          <Route
            exact
            path="/user/operation/agreement"
            element={<Agreement />}
          />
          <Route
            exact
            path="/user/operation/sphere-shortest-path"
            element={<SphereShortestPath />}
          />
          <Route
            exact
            path="/user/operation/joinoperation"
            element={<JoinOperation />}
          />
          <Route
            exact
            path="/user/operation/leafletLab"
            element={<LeafletLab />}
          />
          <Route
            exact
            path="/user/drone/statusflightdrone"
            element={<OperationTable />}
          />

          {/* <Route
            exact
            path="/user/operation/OperationTable"
            element={<OperationTable />}
          /> */}

          <Route element={<PrivateRoutes />}>
            <Route
              exact
              path="/regulator/regulatorstatusflightdrone"
              element={<RegulatorStatusflightDrone />}
            />
            <Route
              exact
              path="/regulator/regulatordrone"
              element={<RegulatorDrone />}
            />
            <Route
              exact
              path="/regulator/regulatordronemonitoring"
              element={<RegulatorDroneMonitoring />}
            />
            <Route
            exact
            path="/regulator/caatpilotapproval"
            element={<CaatPilotApproval />}
          />
          </Route>
        </Route>
      </Routes>

      <Routes>
        <Route exact path="/login" element={<Login />} />
        <Route exact path="/register" element={<Register />} />
        <Route exact path="/welcome" element={<Welcome />} />
        <Route exact path={"/"} element={<Welcome />} />
        
        {/* <Route exact path={"/"} element={<Navigate to={"/welcome"} />} /> */}
      </Routes>
      {shouldShowNoti && <Notification /> && type_user === "user" && (
        <Notification />
      )}
    </div>
  );
};

export default Routers;
